import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import HospitalVisitSelect from '../06_incurr_trms/HospitalVisitSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';

const TrmsCourse = () => {


    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30 + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: 'ALL',
    });

    const [desc, setDesc] = useState('');

    const searchParamsAdditional = { userAuth: localStorage.getItem("userAuth"), };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['기관명', 'ISS', '전체', '직접 내원', '외부에서 전원', '외래에서 의뢰', '기타', '미상', '미입력']; //component화 
    const dataColumn = ['TRMSEMNM', 'ISS_DIV', 'INRT_TOTAL', 'INRT1_CNT', 'INRT2_CNT', 'INRT3_CNT', 'INRT8_CNT', 'INRT9_CNT', 'INRTNULL_CNT'];
    const apiCall = '/trmsapi/patientstat/bdtongtrms_stat_course_search.do';
    const apiCntCall = '';
    const excelFileName = `${desc || '전체'}_외상환자 내원경로별 현황`;
    const excelHead = [];
    const mergeConfig = [{ key: 'TRMSEMNM', row: null }];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['15%', '10%', '10%'],
        wrapTF: true,
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="24%" />
                        <col width="10%" />
                        <col width="18%" />
                        <col width="10%" />
                        <col width="18%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <HospitalVisitSelect
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                setDesc={setDesc}
                            />
                        </tr>
                        <tr>
                            <th>환자분류</th>
                            <td>
                                <select id="searchCheck1"
                                    name="searchCheck1"
                                    value={searchParams.searchCheck1}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="2">응급센터</option>
                                    <option value="1">외상센터</option>
                                </select>
                            </td>
                            <th>성별</th>
                            <td>
                                <select id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    <option value="ALL">전체</option>
                                    <option value="M">남자</option>
                                    <option value="F">여자</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <p> * 외상등록체계 전송 대상자 중 ‘외상환자 제외’ 및 ‘연동 후 제외’, ‘외상 삭제’ 제외 </p>
        </Main>
    )
}

export default TrmsCourse;